import { combineReducers } from 'redux';
import { binCollectionsReducer } from './binCollectionsReducer';
export const rootReducer = combineReducers({
  binCollections: binCollectionsReducer,
});

export type State = ReturnType<typeof rootReducer>

